
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Blur from 'vux/src/components/blur/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import { DEFAULT_IMG } from "@/config/def";
import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
name: "Cd",
data() {
return {
cd: {
logo: DEFAULT_IMG,
headurl: "",
dissname: ""
}
};
},
created: async function () {
try {
this.$store.commit("loadingCtrl", true);
let res = await this.$store.dispatch("getCdList", this.$route.params.id);
let _data = res.data;
if (_data.cdlist.length > 0) {
this.cd = _data.cdlist[0]
}
} catch (error) {
this.$store.commit("notify", { text: "获取数据失败" });
}
this.$store.commit("loadingCtrl", false);
},
computed:{
...mapState({
playing: state => state.PlayService.playing,
})
},
methods: {
backToHome() {
this.$router.go(-1);
},
addToPlaylist(){
if (!!this.cd.songlist && this.cd.songlist.length>0) {
this.$store.commit("concatToPlayList",this.cd.songlist)
this.$store.commit("notify", { text: "已加入播放列表" });
if (!this.playing) {
this.$store.commit('playIndex',0)
}
}
},
...mapMutations(['loadingCtrl'])
},
components: { Group, CellBox, XButton, Blur, Flexbox, FlexboxItem }
};




// WEBPACK FOOTER //
// ./src/components/Cd.vue